import DiscountsTable from "../components/discount/discountsTable";
import AddLink from "../components/form/addLink.comp";
import Layout from "../components/layouts/layout.comp";
import { ListSection } from "../components/reuseables/list.comp";
import { useTranslation } from "../core/translation.core";

export default function ScheduleDiscountsPage() {
  const { t, msg } = useTranslation();

  return (
    <Layout title={t(msg.discount.scheduleDiscount)} titleBtn={<Btn />}>
      <ListSection>
        <DiscountsTable />
      </ListSection>
    </Layout>
  );
}

const Btn = () => {
  return <AddLink id="scheduleDiscount-create" href="/scheduleDiscount/create" />;
};
